import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonModal, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input-modal.component.html',
  styleUrls: ['./custom-search-input-modal.component.scss'],
})
export class CustomSearchInputModalComponent implements OnInit {
  @ViewChild(IonModal) modal!: IonModal;
  @Input() Options: { name: string; value: string }[] = [];
  @Input() ModalTitle: string = '';
  searchResults: { name: string; value: string }[] = [];
  @Output() resultEmitter = new EventEmitter<{ name: string; value: string }>();

  constructor(public modalCtrl: ModalController) {}

  async ngOnInit() {
    this.searchResults = this.Options;
  }

  handleInput(event: any) {
    this.searchResults = this.Options;
    const query = event.target.value.toLowerCase();
    this.searchResults = this.searchResults.filter((d) => d.name!.toLowerCase().indexOf(query) > -1);
  }

  async setResult(option: { name: string; value: string }) {
    this.resultEmitter.emit(option);
    await this.modal.dismiss();
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
